<template>
  <div>
    <v-card class="mx-auto">
      <v-img
        height="200px"
        class="grey"
      />
      <v-card-title>{{ organization.label }}</v-card-title>
      <v-card-subtitle>{{ organization.description }}</v-card-subtitle>
      <v-card-text>
        <v-row
          dense
          align="center"
        >
          <v-col
            cols="12"
            sm="auto"
          >
            <v-chip
              small
              outlined
              @click="copyUUID"
            >
              <v-avatar left>
                <v-icon small>
                  mdi-content-copy
                </v-icon>
              </v-avatar>
              {{ $t('UUID') }}
            </v-chip>
            <span class="pl-2 caption">{{ organization.uuid }}</span>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            v-if="organization.ssn !== null && typeof organization.ssn !== 'undefined'"
          >
            <v-chip
              small
              outlined
              @click="copySSN"
            >
              <v-avatar left>
                <v-icon small>
                  mdi-content-copy
                </v-icon>
              </v-avatar>
              {{ this.$t('SSN') }}
            </v-chip>
            <span class="pl-2 caption">{{ organization.ssn }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="primary"
          link
          target="_blank"
          :href="'https://admin.salescloud.is/company/' + organization.uuid + '/switch'"
        >
          {{ $t('switch') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          link
          target="_blank"
          :href="'https://admin.salescloud.is/company/' + organization.uuid + '/edit'"
        >
          {{ $t('manage') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

export default {
	name: 'OrganizationCard',
  props: {
    organization: {
      type: Object,
      default: () => ({})
    }
  },
	data: () => ({
		building: false,
    copyingOrganizationUUID: false,
    copyingOrganizationSSN: false
	}),
	methods: {
		async copyUUID() {
      this.copyingOrganizationUUID = true
			await this.writeToClipboard(String(this.organization.uuid))
      this.copyingOrganizationUUID = false
		},
		async copySSN() {
		  this.copyingOrganizationSSN = true
      await this.writeToClipboard(String(this.organization.ssn))
      this.copyingOrganizationSSN = false
		},
    writeToClipboard(text) {
      window.navigator.clipboard.writeText(text).then(result => {
        return !!result
      }).catch(e => {
        return false
      })
    }
	}
}
</script>
